import Swiper from 'swiper/bundle'

const mountSlider = () => {
  if (document.querySelector('.slider')) {
    const slider = new Swiper('.slider', {
      loop: true,
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1100: {
          slidesPerView: 3,
          spaceBetween: 43,
        },
      },
    })
  }
}

export { mountSlider }
